import script from "./Fold_setup.vue?vue&type=script&lang=ts&setup=true"
export * from "./Fold_setup.vue?vue&type=script&lang=ts&setup=true"

import "./Fold_setup.vue?vue&type=style&index=0&id=2467cc8b&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2467cc8b"]])

export default __exports__